var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkWhite({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5418 3.51871V7.54171C15.5418 7.95592 15.8776 8.29171 16.2918 8.29171C16.706 8.29171 17.0418 7.95592 17.0418 7.54171V1.70837C17.0418 1.29416 16.706 0.958374 16.2918 0.958374H10.4585C10.0443 0.958374 9.7085 1.29416 9.7085 1.70837C9.7085 2.12259 10.0443 2.45837 10.4585 2.45837H14.4808L8.26117 8.67804C7.96828 8.97094 7.96828 9.44581 8.26117 9.7387C8.55407 10.0316 9.02894 10.0316 9.32183 9.7387L15.5418 3.51871Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.2085 3.70837C3.24188 3.70837 2.4585 4.49175 2.4585 5.45837V13.7917C2.4585 14.7583 3.24188 15.5417 4.2085 15.5417H12.5418C13.5084 15.5417 14.2918 14.7583 14.2918 13.7917V9.62504C14.2918 9.21083 14.6276 8.87504 15.0418 8.87504C15.456 8.87504 15.7918 9.21083 15.7918 9.62504V13.7917C15.7918 15.5868 14.3369 17.0417 12.5418 17.0417H4.2085C2.41345 17.0417 0.958496 15.5868 0.958496 13.7917V5.45837C0.958496 3.66333 2.41345 2.20837 4.2085 2.20837H8.37516C8.78938 2.20837 9.12516 2.54416 9.12516 2.95837C9.12516 3.37259 8.78938 3.70837 8.37516 3.70837H4.2085Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkWhite);
export default __webpack_public_path__ + "static/media/link-white.c4d0f0639babf1b11bf4e7924816d686.svg";
export { ForwardRef as ReactComponent };